import { writable } from "svelte/store";
import type { CampaignUser } from "../../types/campaign";

export type CampaignUserStore = {
  campaignUser?: CampaignUser;
  hasLoaded?: boolean;
};

export function setCampaignUser(campaignUser: CampaignUser) {
  campaignUserStore.update((data) => ({ ...data, campaignUser, hasLoaded: true }));
}

export function updateCampaignUser(campaignUser: CampaignUser) {
  campaignUserStore.update((data) => ({ ...data, campaignUser }));
}

export function initStore() {
  const store = writable<CampaignUserStore>();
  store.set({ hasLoaded: false });
  return store;
}

export const campaignUserStore = initStore();
